const TermsConditionsAz = () => {
  return (
    <div>
      <p>
        Siz, bu qaydaları imzalamaqla bu qaydalarda müəyyən edilmiş şərtlərlə
        tam və qeyd-şərtsiz olaraq razılaşdığınızı və həmin şərtləri qəbul
        etdiyinizi bəyan və təsdiq edirsiniz.
      </p>
      <p className="mt-[10px]">
        <span className="mt-[10px] text-[20px] font-semibold">
          1. ƏSAS ANLAYIŞLAR
        </span>{' '}
        <br /> Bu qaydalarda istifadə edilən əsas anlayışlar və onların mənası
        aşağıdakı kimidir: <br />
        <span className="font-semibold">Şirkət</span> –
        “invoice-reporter.com”-un mülkiyyətçisi olan və onun idarə edilməsini
        təşkil və təmin edən “DIGERA&quot; Məhdud Məsuliyyətli Cəmiyyəti (VÖEN:
        2007374731) <br />{' '}
        <span className="font-semibold">“invoice-reporter.com”</span> – Özündə
        gəlirlər və xərclər, əməliyyatçılar, menecerlər, operatorlar və
        layihələr üzrə məlumatların daxil edilməsi və hesabatların
        hazırlanmasının online rejimdə aparılması, invoysların (hesab
        fakturaların) hazırlanması və müştərilərə göndərilməsini, bank
        əməliyyatlarının hərəkəti, gəlir və xərclər üzrə əməliyyatların
        başlanmasından bitməsinə qədər olan bütün mərhələlərin tənzimlənməsini,
        müştərilərlə bağlı məlumatları, onlar haqqında qeyd və tapşırıqları,
        istifadəçinin fəaliyyətini ehtiva edən proqram təminatıdır. <br />{' '}
        <span className="font-semibold">İstifadəçi</span> –
        “invoice-reporter.com”-dan ondan istifadə edən hər hansı bir şəxs
        (hüquqi və fiziki) nəzərdə tutulur. <br />
        <span className="font-semibold">Şəxsi məlumatlar</span> – istifadəçini
        birbaşa və ya dolayı yolla müəyyən etməyə imkan verən şəxsi xarakterli
        istənilən məlumat. <br />
        <span className="font-semibold">İnternet səhifəsi</span> –
        www.invoice-reporter.com <br />
        <span className="font-semibold">Mobil tətbiq (əlavə):</span> 
        “invoice-reporter.com” adı altında App Store və Play marketdən yüklənmiş
        mobil əlavə
        <br /> <span className="font-semibold">Qeydiyyat</span> – Şəxsi
        məlumatları daxil edərək və bu Qaydalar ilə razılaşaraq
        “invoice-reporter.com”-dan istifadə etməyə imkan verən prosess.   Səhifə
        2 / 6 <br /> <span className="font-semibold">Hesab</span> – Şəxsi –
        İstifadəçi barədə məlumatları özündə əks etdirən və “invoice-
        reporter.com”-dən istifadə etməyə imkan verən səhifə. <br />{' '}
        <span className="font-semibold">Tarif</span>  –
        “invoice-reporter.com”-dən istifadəyə görə müstəsna olaraq Şirkət
        tərəfindən müəyyən edilən pul məbləği.   Bu qaydalar
        “invoice-reporter.com”-dan istifadə etməyin qayda və şərtlərini müəyyən
        edir və Şirkət və istifadəçi arasında olan hüquqi münasibətləri
        tənzimləyir.
      </p>
      <p className="mt-[10px]">
        Bu qaydalar “invoice-reporter.com”-dan istifadə etməyin qayda və
        şərtlərini müəyyən edir və Şirkət və istifadəçi arasında olan hüquqi
        münasibətləri tənzimləyir.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          2. “invoice-reporter.com”-da QEYDİYYAT
        </span>{' '}
        <br />
        “invoice-reporter.com”-dən istifadə etmək üçün ilk növbədə İstifadəçi
        internet səhifəsi vasitəsi ilə qeydiyyatdan keçməlidir. Qeydiyyatdan
        keçmək üçün müvafiq məlumatları daxil etdikdən və zəruri addımları icra
        etdikdən İstifadəçi üçün fərdi hesab yaradılacaq və İstifadəçi müstəqil
        olaraq hesabına məlumatları əlavə edə və hesabını idarə edə bilər.
        Yalnız bütün məlumatlar müvafiq istifadəçi təlimatına uyğun və doğru
        şəkildə daxil edildiyi zaman hesab yaradılır. Qeydiyyat zamanı
        İstifadəçi tərəfindən daxil edilən məlumatların düzgünlüyünə və
        qeydiyyatdan sonra İstifadəçiyə aid məlumatlarda baş vermiş
        dəyişikliklərin mütəmadi olaraq yenilənməsinə görə İstifadəçi məsuliyyət
        daşıyır. Qeydiyyat zamanı İstifadəçinin daxil etdiyi məlumatların səhv,
        saxta və yalan olmasının müəyyən edildiyi və bununla bağlı əsaslı
        şübhələr olduğu halda Şirkət, İstifadəçinin hesabını məhdudlaşdırmaq,
        bloklamaq, silmək və “invoice- reporter.com”-dan istifadəsini qadağan
        etmək hüququna malikdir. Həmçinin Şirkət zəruri hesab etdiyi halda yalan
        qeydiyyat faktının araşdırılması üçün zəruri olan məlumatları Hüquq
        Mühafizə Orqanlarına verə bilər. Azərbaycan Respublikasının
        qanunvericiliyinin tələblərinə uyğun olaraq “invoice- reporter.com”
        yalnız İstifadəçi tərəfinizdən daxil edilmiş fərdi məlumatları toplayır
        və işləyir. İstifadəçi öz fərdi məlumatlarını daxil etməklə həmin
        məlumatların “invoice-reporter.com” tərəfindən toplanmasına və
        işlənməsinə icazə vermiş hesab olunur.  İstifadəçi
        “invoice-reporter.com”-dan istifadə edərkən öz hərəkət və ya
        hərəkətsizliyinin nəticələrinə (hər hansi şərtlərlə üçüncü şəxslərin
        hesabına daxil olmaq və ya üçüncü şəxslərin onun hesabından istifadə
        etməsinə icazə vermək Səhifə 3 / 6 və sairə), həmçinin məlumatlarin
        məxfiliyinə riayət edilməməsinə görə özü cavabdehlik daşıyır.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          3. LOQİN (E-MAIL) VƏ ŞİFRƏ
        </span>{' '}
        <br />
        “invoice-reporter.com”-da qeydiyyata alınma müvəffəqiyyətlə başa
        çatdıqda İstifadəçi üçün fərdi hesab yaradılacaq. Qeydiyyat zamanı
        İstifadəçi öz hesabına daxil olmaq üçün özü tərəfindən müəyyən edilmiş
        loqin (e-mail) və şifrə seçməlidir. Şirkət müəyyən loqinlərdən
        istifadəni qadağan edə, həmçinin şifrə üçün müəyyən zəruri tələblər qoya
        bilər (istifadə ediləcək simvolların sayı, miqdarı və sairə).  
        İstifadəçinin seçdiyi loqin (e-mail) və şifrə mühüm və məxfi məlumatdir.
        Onun məxfi saxlanılması istifadəçinin vəzifəsidir və onun maraqlarının
        qorunması üçündür. Hesabınızın təhlükəsizliyini təmin etmək üçün
        “invoice-reporter.com” ilə icra etdiyiniz hər bir sessiyasının sonunda
        hesabınızdan müstəqil şəkildə çıxışı (“çıxış” düyməsi vasitəsilə) həyata
        keçirməyiniz tələb olunur. Əks halda “invoice- reporter.com”-da
        məlumatların itməsinə və baş verə biləcək istənilən digər mənfi
        nəticələrə görə Şirkət məsuliyyət daşımır. İstifadəçi hesabına girişin
        məhdudlaşdırıldığını, həmçinin şifrə və parolunun məxfiliyinin
        pozulduğunu aşkar və ya güman edərsə dərhal bu barədə Şirkəti xəbərdar
        etməlidir. İstifadəçinin bu kimi hallara cəld reaksiya verməsi Şirkətin
        təhlükəsizlik tədbirlərini səmərəli şəkildə icra etməsinə kömək edir.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          4. HESABIN MƏHDUDLAŞDIRILMASI VƏ SİLİNMƏSİ
        </span>{' '}
        <br />
        İstifadəçi bu Qaydaların şərtlərini pozduğu halda Şirkət müstəsna
        səlahiyyətlərindən istifadə edərək səbəblərini göstərmədən bütün məzmun
        daxil olmaqla İstifadəçinin hesabını məhdudlaşdıra, blok edə, silə və
        istifadəsini qadağan edə bilər. Həmin andan İstifadəçinin hesabından və
        hesabda olan məlumatlardan istifadəsi, hesabdan istifadənin bərpası
        həmin məlumatların bərpası və hesabda olan məlumatların bərpası mümkün
        olmayacaq.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">5. ÖDƏNİŞ QAYDASI</span>{' '}
        <br />
        “invoice-reporter.com”-dan istifadə ödənişlidir. Şirkət
        “invoice-reporter.com”-dan istifadənin ilk 90 (doxsan) gününü sınaq
        müddəti kimi pulsuz təmin edə bilər. Sınaq müddəti başa çatdıqdan sonra
        “invoice-reporter.com”-dan istifadə etmək üçün ödəniş, Şirkətin saytında
        yerləşdirilən tarif cədvəli və ödəniş şərtlərinə müvafiq olaraq icra
        edilməlidir. Səhifə 4 / 6 Tarif cədvəlində “invoice-reporter.com”-dan
        istifadəyə görə ödənilməli olan haqqın məbləğinin dəyişdirilməsi və ona
        əlavələrin edilməsi Şirkətin müstəsna hüququdur. İstifadəçi ona uyğun
        olan tarifi seçməklə “invoice-reporter.com”-dan istifadəyə görə ödəniş
        etmək öhdəliyini öhdəsinə götürür. İstifadəçi “invoice-reporter.com”-
        dan istifadəyə görə ödənişi vaxtında və tam şəkildə icra etməlidir.
        Ödənişlər gec və ya natamam icra edildiyi halda İstifadəçinin
        “invoice-reporter.com”-dən istifadə hüququ məhdudlaşdırılacaq.   Ödəniş
        internet səhifəmiz üzərindən, bank kartları (VİSA / MasterCard və
        digərləri) və şirkətin hesablaşma hesabına pul vəsaitlərinin köçürülməsi
        yolu ilə icra edilə bilər.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          6. ƏQLİ MÜLKİYYƏT VƏ DİGƏR HÜQUQLARININ QORUNMASI
        </span>{' '}
        <br />
        “invoice-reporter.com” proqram təminatına dair hüquqlar Şirkətə
        məxsusdur. Şirkət bu Qaydalarda ifadə edilmiş və ya edilməmiş bütün
        hüquqları özündə saxlayır. Bu Qaydalarla razılaşmaqla İstifadəçi
        “invoice-reporter.com”-ı satın almır, yalnız “invoice-reporter.com”-dan
        istifadə hüququ əldə edir.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          7. İSTİFADƏÇİNİN HÜQUQLARININ MƏHDUDLAŞDIRILMASI
        </span>{' '}
        <br />
        İstifadəçi proqram təminatının surətini çıxara, onu yenidən yarada,
        tərkib hissələrinə ayıra, sökə və ya proqram təminatının mənbə kodu və
        ya alqoritmlərini aşkarlamağa çalışa, proqram təminatının hər hansı bir
        xüsusiyyətini dəyişə, yararsız hala salmaq məqsədi ilə ona kiber hücum
        edə və proqram təminatından başqa məqsədlər üçün istifadə edə bilməz.
        İstifadəçi proqram təminatını üçüncü şəxslərə istifadəyə verə bilməz.
        Şirkət, İstifadəçi tərəfindən hər hansı qeyri-qanuni istifadəni müşahidə
        edərsə heç bir əlavə bildiriş göndərmədən İstifadəçinin
        “invoice-reporter.com”-dan istifadəsini məhdulaşdıra və hesabını heç bir
        məbləğ geri qaytarmadan ləğv edə bilər.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          8. İSTİFADƏÇİNİN ÖHDƏLİKLƏRİ
        </span>{' '}
        <br />
        yerləşdirilən və ya “invoice-reporter.com” sistemi ilə ötürülən
        məlumatlar üzrə araşdırma və yoxlamalar aparmır. Məlumatların
        göndərilməsi və “invoice- reporter.com”-dan qanunvericiliyə uyğun
        şəkildə istifadə olmasına görə İstifadəçi özü məsuliyyət daşıyır. Səhifə
        5 / 6 “invoice-reporter.com”-dan istifadə etməyi qəbul etməklə
        İstifadəçi qeyd-şərtsiz razılaşır ki, “invoice-reporter.com”-dan
        istifadə edərkən Azərbaycan Respublikasının qanunvericliyinə əməl
        edəcək. “invoice-reporter.com”-dan istifadə zamanı yol verdiyi hər hansı
        qeyri-qanuni əməllərə görə İstifadəçi şəxsən özü məsuliyyət daşıyır.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          9. MƏLUMATLARDAN İSTİFADƏYƏ RAZILIQ
        </span>{' '}
        <br />
        İstifadəçi qəbul və təsdiq edir ki, “invoice-reporter.com”-dan istifadə
        edərkən öz fərdi məlumatlarını serverə ötürür. Şirkət isə fərdi
        məlumatların mühafizəsinə dair qanunvericiliyin tələblərinə riayət
        etməklə fərdi məlumatların ötürülməsi və işlənilməsini icra və təmin
        edir. Həmçinin İstifadəçi qəbul və təsdiq edir ki, ona aid olan
        məlumatların Azərbaycan Respublikası ərazisindən kənarda yerləşən
        beynəlxalq serverlərdə saxlanılmasına etiraz etmir.  
        “invoice-reporter.com”-dan istifadə zamanı İstifadəçi qeyd şərtsiz ona
        məxsus olan fərdi məlumatlarınızın işlənməsinə (fərdi məlumatların
        yazılması, sistemləşdirilməsi, təzələnməsi, dəyişdirilməsi, çıxarılması,
        saxlanılması, ötürülməsi, məhv edilməsi və sairəyə) icazə verir.
        İstifadəçinin məlumatları xarici ölkələrdə yerləşən “buludlarda”
        yerləşdirilə bilər. İstifadəçi qeyd şərtsiz olaraq fərdi məlumatlarının
        trans sərhəd ötürülməsinə və xarici ölkələrdə yerləşən buludlarda
        yerləşdirilməsinə, saxlanılmasına və işlənilməsinə razılıq verir.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">10. ZƏMANƏT</span> <br />
        İstifadəçi tərəfindən “invoice-reporter.com”-dan istifadə ilə bağlı
        daxil edilmiş bütün məlumatların qorunması və saxlanmasına Şirkət
        məsuliyyət daşıyır. “invoice-reporter.com”-dan istifadə nəticəsində
        İstifadəçiyə dəymiş zərərə görə Şirkətin İstifadəçi qarşısında
        məsuliyyəti İstifadəçinin Şirkətə ödədiyi məbləğdən artıq ola bilməz.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          11. MƏSULİYYƏTİN MƏHDUDLAŞDIRILMASI
        </span>{' '}
        <br />
        “invoice-reporter.com”-dan istifadə etmək və ya ondan istifadə edə
        bilməmək nəticəsində yaranan, həmçinin proqramdan istifadə zamanı yarana
        biləcək xətalar nəticəsində və ya onunla bağli yaranmış zərərlər,
        çatışmamazlıqlar, kənar müdaxilələr, nöqsanlar, əməliyyatda və ya
        ötürmədə ləngimələr, kompüter virusu, qoşula bilməmə nəticəsində
        yaranmış hər hansı bir zərərə görə Şirkət heç bir məsuliyyət daşımır.
        Səhifə 6 / 6 Yalan və saxta məlumatlar əsasında hesab yaratmaqla edilmiş
        əməliyyatlara görə Şirkət məsuliyyət daşımır. “invoice-reporter.com”-da
        hazırlanan sənədlərin (hesabatların, invoysların, bank əməliyyatları
        üzrə sənədlərin və s.) düzgünlüyünə Şirkət məsuliyyət daşımır.
        “invoice-reporter.com”-da sənədlərin hazırlanması zamanı daxil etdiyiniz
        hər hansı bir səhv məlumat nəticəsində yaranmış ziyana görə Şirkət
        məsuliyyət daşımır.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          12. YENİLƏNMƏ VƏ SAZLAMALAR
        </span>{' '}
        <br />
        Şirkət “invoice-reporter.com”-un daimi işlək vəziyyətdə olması və
        keyfiyyətli işləməsi üçün “invoice-reporter.com”-da mütəmadi olaraq
        yeniləmə, sazlama, təkmilləşmə və digər zəruri işləri icra edə bilər.
        Yenilənmiş “invoice-reporter.com”-a yeni funksiyalar əlavə edilə və bəzi
        hallarda mövcud funksiyalar silinə bilər.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          13. “invoice-reporter.com”-un ÜÇÜNCÜ TƏRƏFƏ VERİLMƏSİ
        </span>{' '}
        <br />
        İstifadəçi “invoice-reporter.com” və ya onunla bağlı digər proqram
        təminatından istifadə üzrə İstifadəçiyə verilmiş hüquqları heç bir halda
        və şəkildə üçüncü tərəfə ötürə bilməz.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          14. TƏTBİQ OLUNAN HÜQUQ VƏ MÜBAHİSƏLƏRİN HƏLLİ QAYDASI
        </span>{' '}
        <br />
        Bu Qaydalar Azərbaycan Respublikasının qanunvericiliyi ilə tənzimlənir
        və ona uyğun təfsir olunur. Bu Qaydalardan irəli gələn
        “invoice-reporter.com” və ya onunla bağlı olan bütün mübahisələr
        tərəflər arasında danışıqlar yolu ilə həll edilə bilmədikdə Azərbaycan
        Respublikasının müvafiq məhkəmələri tərəfindən və Azərbaycan
        Respublikasının qanunvericiliyinə əsasən həll edilir.
      </p>
    </div>
  );
};

export default TermsConditionsAz;
